import React, { useContext, useState } from 'react';
import get from 'lodash/get';
import set from 'lodash/set';

import FormContext from 'src/presentation/contexts/FormContext';
import InputField from 'src/presentation/components/forms/InputField';
import { getNumberValue } from '@ad-scripts/presentation/components/common/input_field';
import {
  convertMinutesToSeconds,
  convertSecondsToMinutes,
} from 'src/presentation/components/pages/shared/utils/TimeUtils';

const SlaMinutesInputField = (props): JSX.Element => {
  const { attr, ...otherProperties } = props;
  const { errors, resetError, updateState, workingState } = useContext(FormContext);

  const valueInSeconds = get(workingState, attr, 0);
  const valueInMinutes = convertSecondsToMinutes(Number(valueInSeconds));

  const [input, setInput] = useState(valueInMinutes.toString());

  const onChangeHandler = (value = '') => {
    const [numberValue, isValid] = getNumberValue(value);

    if (!isValid) {
      return false;
    }

    setInput(value);

    resetError({ attr, errors });
    updateState(set({}, attr, convertMinutesToSeconds(numberValue)));
  };

  return <InputField attr={attr} {...otherProperties} onChange={onChangeHandler} value={input} />;
};

export default SlaMinutesInputField;
